export class ProductComponentsEndpoints {
    private static readonly BASE = '/api/warehouse/product';

    static list(productExternalId: string): string {
        return `${this.BASE}/${productExternalId}/components`;
    }

    static set(productExternalId: string): string {
        return `${this.BASE}/${productExternalId}/components`;
    }
}